import type {RawVendorPartner, VendorPartner} from '@/types/vendor-partner';

export const mapRawToVendorPartner = (raw : RawVendorPartner) : VendorPartner => raw;
